import React, { createContext, MutableRefObject, useRef } from 'react';

import { FilterData } from '../types';

export const AiSmartFilterContext = createContext<MutableRefObject<FilterData>>(
    { current: {} }
);

interface AiSmartFilterProviderProps {
    children: React.ReactNode;
}

const AiSmartFilterProvider = ({ children }: AiSmartFilterProviderProps) => {
    const state = useRef<FilterData>({});

    return (
        <AiSmartFilterContext.Provider value={state}>
            {children}
        </AiSmartFilterContext.Provider>
    );
};

export default AiSmartFilterProvider;
